export var   adjectives = [{
    text: 'きれい',
    trans: 'beautiful',
    type: 'na'
  }, {
    text: 'おおきい',
    trans: 'big',
    type: 'i'
  }, {
    text: 'いそがしい',
    trans: 'busy',
    type: 'i'
  }, {
    text: 'げんき',
    trans: 'healthy',
    type: 'na'
  }, {
    text: 'さむい',
    trans: 'cold (weather)',
    type: 'i'
  }, {
    text: 'つめたい',
    trans: 'cold (to touch)',
    type: 'i'
  }, {
    text: 'べんり',
    trans: 'convenient',
    type: 'na'
  }, {
    text: 'おいしい',
    trans: 'delicious',
    type: 'i'
  }, {
    text: 'やさしい',
    trans: 'kind',
    type: 'i'
  }, {
    text: 'たかい',
    trans: 'expensive',
    type: 'i'
  }, {
    text: 'ゆうめい',
    trans: 'famous',
    type: 'na'
  }, {
    text: 'たのしい',
    trans: 'fun',
    type: 'i'
  }, {
    text: 'いい',
    trans: 'good',
    type: '*'
  }, {
    text: 'あつい',
    trans: 'hot',
    type: 'i'
  }, {
    text: 'あたらしい',
    trans: 'new',
    type: 'i'
  }, {
    text: 'ひま',
    trans: 'free time',
    type: 'na'
  }, {
    text: 'ふるい',
    trans: 'old',
    type: 'i'
  }, {
    text: 'しずか',
    trans: 'quiet',
    type: 'na'
  }, {
    text: 'ちいさい',
    trans: 'small',
    type: 'i'
  }, {
    text: 'あたたかい',
    trans: 'warm',
    type: 'i'
  }];